import { FunctionComponent } from 'react';
import { styled } from 'styled-components';

const CounterIcon = styled.span`
	background-color: ${({ theme }) => theme.colors.bgSell};
	color: ${({ theme }) => theme.colors.textDefault};
	border-radius: 50%;
	font-weight: 700;
	font-size: 12px;
	width: 22px;
	height: 22px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 1px;
	padding-right: 1px;
`;

export const Counter: FunctionComponent<{ count: number | undefined }> = ({
	count,
}) => {
	if (!count || count === 0) return null;
	const display = count <= 9 ? count.toString() : '9+';

	return <CounterIcon>{display}</CounterIcon>;
};
